var ua = window.navigator.userAgent;
var platform = window.navigator.platform;

function isiOS() {
  return [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.userAgent.includes("Mac") && "ontouchend" in document);
}

function flickityInit() {
  // Flickity.defaults.cellSelector = '.carousel-cell';
  Flickity.defaults.cellAlign = 'left';
  // Flickity.defaults.pageDots = false;
  // Flickity.defaults.autoPlay = false;
  // Flickity.defaults.pauseAutoPlayOnHover = true;
  Flickity.defaults.contain = true;
  // Flickity.defaults.counter = true;
  // Flickity.defaults.draggable = true;
  // Flickity.defaults.fade = false;
  // Flickity.defaults.freeScroll = false;
  // Flickity.defaults.groupCells = false;
  // Flickity.defaults.imagesLoaded = true;
  Flickity.defaults.pageDots = false;
  // Flickity.defaults.prevNextButtons = false;
  Flickity.defaults.wrapAround = false;
  Flickity.defaults.watchCSS = true;
  Flickity.defaults.on = Flickity.defaults.on || {};

  if (isiOS()) {
    Flickity.defaults.resize = false
  }
  
  // Flickity.defaults.on.activate = function(){
  //   console.log('activate');
  // }

  // Flickity.defaults.on.deactivate = function(){
  //   console.log('deactivate');
  // }

  var dataName = 'data-carousel';
  var sliders = document.querySelectorAll(`[${dataName}]`);

  // console.log(sliders);

  if (!sliders.length) return;

  function onScroll(slider, wrapper){
    if (!slider.isActive) return;

    var scrollViewportSize = 1 - (slider.slidesWidth / slider.slideableWidth);
    wrapper.style.setProperty('--additive-progress', scrollViewportSize * 100 + '%');
    wrapper.style.setProperty('--scroll-size', scrollViewportSize * 100 + '%');

    // * Get correct progress value
    var scrollProgress = -slider.x / slider.slidesWidth;
    var fullProgress = Math.max(0, Math.min(1, scrollProgress));
    
    // * For full progress bar
    wrapper.style.setProperty('--progress', fullProgress * 100 + '%');
    
    // * For additive progress bar
    var mergedProgress = scrollViewportSize + scrollProgress * (1 - scrollViewportSize);
    wrapper.style.setProperty('--additive-progress', mergedProgress * 100 + '%');
    
    // * For scrollbar
    var scrollLeft = scrollProgress * (1 - scrollViewportSize);
    wrapper.style.setProperty('--scroll-left', scrollLeft * 100 + '%');
  }

  sliders.forEach((element, index) => {
    var dataOptions = element.getAttribute(dataName);
    var options = dataOptions ? JSON.parse(dataOptions) : {};

    var slider = new Flickity(element, options);
    var wrapper = slider.element.closest('.carousel-wrapper');

    if (!wrapper) {
      console.warn('carousel wrapper element not found: ', slider);
      return
    };

    var controls = element.querySelector('.carousel-controls');
    if (!controls) {
      controls = document.createElement('div');
      controls.classList.add('carousel-controls');
    }

    if (!!options.progressBar) {
      var progressBar = element.querySelector('.carousel-progress');

      if (!progressBar) {
        var progressBar = document.createElement('div');
        progressBar.classList.add('carousel-progress');
        controls.appendChild(progressBar);
      }
    }

    if (!!options.scrollbar) {
      var scrollbar = element.querySelector('.carousel-scrollbar');

      if (!scrollbar) {
        var scrollbar = document.createElement('div');
        scrollbar.classList.add('carousel-scrollbar');
        controls.appendChild(scrollbar);
      }
    }

    // ! iOS で正常にスライドできないバグ対策
    // https://github.com/metafizzy/flickity/issues/1177
    if (isiOS()) {
      slider.on('settle', function (index) {
        if (slider.resizeQueued) {
          slider.resizeQueued = false;
          slider.onresize();
        }
      });

      window.addEventListener('resize', function () {
        if (slider.isAnimating) {
          slider.resizeQueued = true;
        } else {
          slider.onresize();
        }
      });

      // slider.on('dragStart', () => (document.ontouchmove = e => e.preventDefault()));
      slider.on('dragStart', () => (document.ontouchmove = () => false));
      slider.on('dragEnd', () => (document.ontouchmove = () => true));

      document.body.addEventListener('touchstart', (ev) => {
        document.ontouchmove = () => true;
      });
    }

    slider.on('scroll', function(){
      onScroll(slider, wrapper)
    });

    slider.on('activate', function(){
      slider.element.classList.add('flickity-activated');
      slider.element.classList.remove('flickity-deactivated');

      // watchCSS で破壊した後にもう一度生成するとカスタムで付与したイベントは消えるので再度付与する必要がある
      slider.on('scroll', function(){
        onScroll(slider, wrapper)
      });
    });

    slider.on('deactivate', function(){
      slider.element.classList.remove('flickity-activated');
      slider.element.classList.add('flickity-deactivated');
    });

    wrapper.appendChild(controls);

    // window.addEventListener('load', function(){
    //   slider.resize();
    // });
  });

  setTimeout(function(){
    window.dispatchEvent(new Event('resize'));
  }, 1000);
}

function customScrollbar() {
  const elements = document.querySelectorAll('.js-static-scrollbar');

  if (!elements.length) return;

  function update(content, scrollbar) {
    let scrollWidth = content.scrollWidth;
    let contentWidth = content.clientWidth;
    let scrollLeft = content.scrollLeft;

    let scrollbarWidth = (contentWidth / scrollWidth) * scrollbar.clientWidth;
    let scrollbarLeft = (scrollLeft / (scrollWidth - contentWidth)) * (scrollbar.clientWidth - scrollbarWidth);

    scrollbar.style.setProperty('--scrollbar-width', scrollbarWidth + 'px');
    scrollbar.style.setProperty('--scrollbar-left', scrollbarLeft + 'px');
  }

  elements.forEach(element => {
    const scrollable = element;
    const id = scrollable.id;
    const scrollbar = document.querySelector(`[data-scrollbar-for="${id}"]`);

    if (!scrollbar) {
      console.log('scrollbar not found');
      return;
    }

    const initializeScrollbar = () => {
      update(scrollable, scrollbar);

      scrollable.addEventListener('scroll', () => update(scrollable, scrollbar));
      window.addEventListener('resize', () => update(scrollable, scrollbar));
    };

    const isEmpty = (el) => !el.children.length && !el.textContent.trim();

    if (isEmpty(scrollable)) {
      // If the scrollable element is empty, observe for changes
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            observer.disconnect(); // Stop observing after content is added
            initializeScrollbar();
            break;
          }
        }
      });

      observer.observe(scrollable, {
        childList: true,
        subtree: true,
      });
    } else {
      // Initialize immediately if the element is not empty
      initializeScrollbar();
    }
  });
}


function footerAccordionMenu() {
  var links = document.querySelectorAll('.footer-block__details-content .list-menu--level-2  .list-menu__list');

  if (!links.length) return;

  links.forEach((menu, index) => {
    var trigger = menu.querySelector('.list-menu__item--link');
    var submenu = menu.querySelector('.list-menu__item--link + .submenu');

    if (!trigger || !submenu) return;

    menu.classList.add('has-submenu');
    menu.classList.add('accordion-group');
    trigger.classList.add('accordion-trigger');
    submenu.classList.add('accordion-menu');
    submenu.style.setProperty('--scroll-height', submenu.scrollHeight + 'px');

    trigger.addEventListener('click', function(e){
      if (window.innerWidth < 750) { // モバイルのみ
        e.preventDefault();
        menu.classList.toggle('accordion-active');
      }
    });
  });
}

function aboutRabHistory(){
  var container = document.querySelector('.about-rab__history__text-content');
  var button = document.querySelector('.about-rab__history__view-more button');
  var timetable = document.querySelector('.about-rab__history__timetable');

  if (!button || !timetable) return;

  function onResize(){
    timetable.style.setProperty('--scroll-height', timetable.scrollHeight + 'px');

    console.log(timetable.offsetHeight);
    console.log(timetable.scrollHeight);

    if (timetable.offsetHeight >= timetable.scrollHeight ) {
      container.classList.add('short-of-content');
    } else {
      container.classList.remove('short-of-content');
    }
  }

  onResize();

  button.addEventListener('click', function(){
    container.classList.toggle('is-expanded');
    button.parentElement.classList.add('clicked');
  });

  window.addEventListener('resize', function(){
    onResize();
  }, {passive: true})
}

function productThumnailCheckLoad(){
  var items = document.querySelectorAll('.thumbnail-list__item');

  if (!items.length) return;

  items.forEach(function(elm){
    var img = elm.querySelector('img');

    if (img.complete && img.naturalWidth > 0) {
      elm.classList.add('image-loaded');
    } else if (img.readyState === 'loading') {
      img.addEventListener('load', function(){
        elm.classList.add('image-loaded');
      })
    }
    
  })
}

function disableProductForm(){
  var form = document.querySelector('.product-form form');

  if (!form) return;

  form.addEventListener('submit', function(){
    event.preventDefault();
    console.warn("Form submission prevented");
  });
}

class SimpleCarousel {
  constructor(carouselSelector) {
    // Select elements
    this.container = document.querySelector(`${carouselSelector}`);
    this.slider = this.container.querySelector(`.carousel-viewport`);
    this.slides = this.container.querySelectorAll(`.carousel-item`);
    this.prevButton = this.container.querySelector(`.carousel-button--prev`);
    this.nextButton = this.container.querySelector(`.carousel-button--next`);

    this.currentIndex = 0;

    // Bind methods
    this.scrollToItem = this.scrollToItem.bind(this);
    this.prevSlide = this.prevSlide.bind(this);
    this.nextSlide = this.nextSlide.bind(this);

    this.initEvents();
  }

  scrollToItem(index) {
    this.slides[index].scrollIntoView({
      behavior: 'smooth',
      inline: 'start',
      block: 'nearest', // Prevent vertical scrolling
    });
  }

  prevSlide() {
    this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
    this.scrollToItem(this.currentIndex);
  }

  nextSlide() {
    this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    this.scrollToItem(this.currentIndex);
  }

  initEvents() {
    this.prevButton.addEventListener('click', this.prevSlide);
    this.nextButton.addEventListener('click', this.nextSlide);
  }
}

document.addEventListener('DOMContentLoaded', function(){
  flickityInit();
  // footerAccordionMenu(); // ページ移動していると不発する？
  // aboutRabHistory();
  productThumnailCheckLoad();

  var cssCarousel = new SimpleCarousel('.menu-drawer__topics .carousel');

  // ! 販売開始後に消す
  disableProductForm();
});

window.addEventListener('load', function(){
  customScrollbar();
  footerAccordionMenu(); // ページ移動していると不発するのでページを完全に読み込んでから
  
  setTimeout(function(){
    window.dispatchEvent(new Event('resize'));
  }, 1000);
});